import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  backLink?: string;
  backText?: string;
}

const PageHeader = ({
  title,
  subtitle,
  backLink,
  backText = 'Voltar para Lista'
}: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      {backLink && (
        <div className="flex items-center space-x-4 mb-4">
          <button
            onClick={() => navigate(backLink)}
            className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 transition-colors"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>{backText}</span>
          </button>
        </div>
      )}
      <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
      <p className="text-gray-600">{subtitle}</p>
    </div>
  );
};

export default PageHeader;
